<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<p class="fm03">You are gone. The river is high at my door.</p>
<p class="fm01">Cicadas are mute on dew-laden boughs.</p>
<p class="fm01">This is a moment when thoughts enter deep.</p>
<p class="fm01">I stand alone for a long while.</p>
<p class="fm01"> … The North Star is nearer to me now than spring,</p>
<p class="fm01">And couriers from your southland never arrive—</p>
<p class="fm01">Yet I doubt my dream on the far horizon</p>
<p class="fm01">That you have found another friend.</p>
<p class="fm01t">Li Shang-yin, <em class="italic">Thoughts in the Cold</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?39bdcc44